// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"09116ea2","442":"cc8275a7","453":"d320a7be","575":"63299ce5","584":"4a80bc2d"}[chunkId] + ".chunk.js";
};